(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["ct-blog-posts"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('ct-blog-posts')) {
    customElements.define(
      'ct-blog-posts',
      class CtBlogPosts extends HTMLElement {
        connectedCallback() {
          this.buttons = Array.from(this.querySelectorAll('[data-filter]'));
          this.cards = Array.from(this.querySelectorAll('[data-card]'));
          if (!this.buttons.length || !this.cards.length) return;

          this.reduced = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

          // Pre-split each card's tags once.
          this.cards.forEach((card) => {
            card._tags = (card.dataset.tags || '')
              .split(',')
              .map((t) => t.trim())
              .filter(Boolean);
          });

          // In the theme editor, leave every card visible so merchants can edit
          // each one; the buttons still toggle their active state for preview.
          this.editor = window.Shopify && window.Shopify.designMode;

          this.onClick = this.onClick.bind(this);
          this.buttons.forEach((btn) => btn.addEventListener('click', this.onClick));
        }

        disconnectedCallback() {
          this.buttons.forEach((btn) => btn.removeEventListener('click', this.onClick));
        }

        onClick(event) {
          const btn = event.currentTarget;
          const filter = btn.dataset.filter;

          this.buttons.forEach((b) => {
            const active = b === btn;
            b.classList.toggle('is-active', active);
            b.setAttribute('aria-pressed', active ? 'true' : 'false');
          });

          if (this.editor) return;
          this.apply(filter);
        }

        apply(filter) {
          const matches = (card) => filter === '*' || card._tags.includes(filter);

          // Phase 1: fade out visible cards that no longer match.
          let anyLeaving = false;
          this.cards.forEach((card) => {
            card.style.transitionDelay = '';
            if (!matches(card) && !card.hidden) {
              card.classList.add('is-leaving');
              anyLeaving = true;
            }
          });

          const swap = () => {
            // Hide the cards that faded out.
            this.cards.forEach((card) => {
              if (!matches(card)) {
                card.hidden = true;
                card.classList.remove('is-leaving');
              }
            });

            // Reveal newly-matching cards from a faded start, lightly staggered.
            const entering = [];
            this.cards.forEach((card) => {
              if (matches(card) && card.hidden) {
                card.hidden = false;
                card.classList.add('is-entering');
                entering.push(card);
              }
            });

            if (this.reduced) {
              entering.forEach((card) => card.classList.remove('is-entering'));
              return;
            }

            requestAnimationFrame(() => {
              requestAnimationFrame(() => {
                entering.forEach((card, i) => {
                  card.style.transitionDelay = i * 30 + 'ms';
                  card.classList.remove('is-entering');
                });
              });
            });
          };

          clearTimeout(this._timer);
          if (anyLeaving && !this.reduced) {
            this._timer = setTimeout(swap, 280);
          } else {
            swap();
          }
        }
      }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["ct-experts"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('ct-experts')) {
    customElements.define(
      'ct-experts',
      class CtExperts extends HTMLElement {
        connectedCallback() {
          this.roster = this.querySelector('[data-expert-roster]');
          this.panels = Array.from(this.querySelectorAll('[data-expert-panel]'));
          this.index = 0;
          if (!this.roster || !this.panels.length) return;

          // Lift each panel's authored face button up into the roster bar.
          this.faces = this.panels
            .map((panel, i) => {
              const face = panel.querySelector('[data-expert-face]');
              if (!face) return null;
              face.setAttribute('role', 'tab');
              face.setAttribute('aria-selected', 'false');
              face.tabIndex = -1;
              face.addEventListener('click', () => this.select(i));
              this.roster.appendChild(face);
              return face;
            })
            .filter(Boolean);

          this.roster.addEventListener('keydown', (e) => {
            if (e.key !== 'ArrowRight' && e.key !== 'ArrowLeft') return;
            e.preventDefault();
            const delta = e.key === 'ArrowRight' ? 1 : -1;
            this.select((this.index + delta + this.faces.length) % this.faces.length, true);
          });

          // Touch swipe on the detail area as a bonus on mobile
          const panelsEl = this.querySelector('.ct-experts__panels');
          panelsEl.addEventListener('touchstart', (e) => (this.touchX = e.changedTouches[0].clientX), { passive: true });
          panelsEl.addEventListener(
            'touchend',
            (e) => {
              const dx = e.changedTouches[0].clientX - this.touchX;
              if (Math.abs(dx) < 48) return;
              const next = this.index + (dx < 0 ? 1 : -1);
              if (next >= 0 && next < this.panels.length) this.select(next);
            },
            { passive: true }
          );

          if (window.Shopify && Shopify.designMode) {
            document.addEventListener('shopify:block:select', (e) => {
              const panel = e.target.closest('[data-expert-panel]');
              if (!panel) return;
              const index = this.panels.indexOf(panel);
              if (index > -1) this.select(index);
            });
          }

          this.classList.add('is-initialized');
          this.select(0);
        }

        select(index, focus = false) {
          this.index = index;
          this.panels.forEach((panel, i) => panel.classList.toggle('is-active', i === index));
          this.faces.forEach((face, i) => {
            const active = i === index;
            face.classList.toggle('is-active', active);
            face.setAttribute('aria-selected', active ? 'true' : 'false');
            face.tabIndex = active ? 0 : -1;
          });
          if (focus && this.faces[index]) this.faces[index].focus();
        }
      }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["ct-flavors"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('ct-flavors')) {
    customElements.define(
      'ct-flavors',
      class CtFlavors extends HTMLElement {
        connectedCallback() {
          this.tabs = Array.from(this.querySelectorAll('[data-flavor-tab]'));
          this.panels = Array.from(this.querySelectorAll('[data-flavor-panel]'));
          if (!this.tabs.length) return;

          try {
            this.variantMap = JSON.parse(this.dataset.variantMap || '{}');
          } catch (e) {
            this.variantMap = {};
          }

          this.tabs.forEach((tab, i) => {
            tab.addEventListener('click', () => this.select(i));
          });

          this.querySelector('.ct-flavors__tabs').addEventListener('keydown', (e) => {
            if (e.key !== 'ArrowRight' && e.key !== 'ArrowLeft') return;
            e.preventDefault();
            const delta = e.key === 'ArrowRight' ? 1 : -1;
            const next = (this.index + delta + this.tabs.length) % this.tabs.length;
            this.select(next);
            this.tabs[next].focus();
          });

          // One-way sync: variant picker -> this section. Horizon's
          // VariantUpdateEvent bubbles to document; resource.id is looked
          // up in the Liquid-built variant map. Nothing is ever dispatched
          // back, so selecting a tab here never changes the variant.
          this.onVariantUpdate = (event) => {
            const eventProductId = event.detail?.data?.productId;
            if (eventProductId && this.dataset.productId && String(eventProductId) !== String(this.dataset.productId)) return;
            const variantId = event.detail?.resource?.id;
            if (variantId == null) return;
            const index = this.variantMap[String(variantId)];
            if (typeof index === 'number' && index >= 0 && index < this.tabs.length) this.select(index);
          };
          document.addEventListener('variant:update', this.onVariantUpdate);

          if (window.Shopify && Shopify.designMode) {
            document.addEventListener('shopify:block:select', (e) => {
              const panel = e.target.closest('[data-flavor-panel]');
              if (!panel) return;
              const index = this.panels.indexOf(panel);
              if (index > -1) this.select(index);
            });
          }

          this.select(parseInt(this.dataset.initialIndex || '0', 10) || 0);
          this.classList.add('is-initialized');
        }

        disconnectedCallback() {
          document.removeEventListener('variant:update', this.onVariantUpdate);
        }

        select(index) {
          this.index = index;
          this.tabs.forEach((tab, i) => {
            const active = i === index;
            tab.classList.toggle('is-active', active);
            tab.setAttribute('aria-selected', active ? 'true' : 'false');
            tab.tabIndex = active ? 0 : -1;
          });
          this.panels.forEach((panel, i) => panel.classList.toggle('is-active', i === index));
        }
      }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["ct-quotes"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('ct-quotes')) {
    customElements.define(
      'ct-quotes',
      class CtQuotes extends HTMLElement {
        connectedCallback() {
          this.slides = Array.from(this.querySelectorAll('[data-quote-slide]'));
          this.pills = Array.from(this.querySelectorAll('[data-quote-pill]'));
          this.dotsEl = this.querySelector('[data-quote-dots]');
          this.controls = this.querySelector('.ct-quotes__controls');
          if (!this.slides.length) return;

          this.pills.forEach((pill) => {
            pill.addEventListener('click', () => this.setCategory(pill.dataset.category, true));
          });
          // Auto-rotate: the active dash's fill animation is the timer
          this.addEventListener('animationend', (event) => {
            if (event.animationName === 'ct-quotes-fill') this.step(1);
          });

          this.addEventListener('pointerenter', (event) => {
            if (event.pointerType === 'mouse') this.classList.add('is-paused');
          });
          this.addEventListener('pointerleave', (event) => {
            if (event.pointerType === 'mouse') this.classList.remove('is-paused');
          });
          this.addEventListener('focusin', () => this.classList.add('is-paused'));
          this.addEventListener('focusout', () => this.classList.remove('is-paused'));

          new IntersectionObserver(
            (entries) => this.classList.toggle('is-offscreen', !entries[0].isIntersecting),
            { threshold: 0.3 }
          ).observe(this);

          const slidesEl = this.querySelector('.ct-quotes__slides');
          slidesEl.addEventListener('touchstart', (e) => (this.touchX = e.changedTouches[0].clientX), { passive: true });
          slidesEl.addEventListener(
            'touchend',
            (e) => {
              const dx = e.changedTouches[0].clientX - this.touchX;
              if (Math.abs(dx) >= 48) this.step(dx < 0 ? 1 : -1);
            },
            { passive: true }
          );

          if (window.Shopify && Shopify.designMode) {
            document.addEventListener('shopify:block:select', (e) => {
              const slide = e.target.closest('[data-quote-slide]');
              if (!slide || !this.slides.includes(slide)) return;
              this.classList.add('is-editor');
              const cat = slide.dataset.category;
              if (cat && cat !== this.category) this.setCategory(cat);
              const index = this.list.indexOf(slide);
              if (index > -1) this.show(index, true);
            });
            document.addEventListener('shopify:block:deselect', () => this.classList.remove('is-editor'));
          }

          this.setCategory(this.pills.length ? this.pills[0].dataset.category : null);
        }

        setCategory(category, manual = false) {
          this.category = category;
          // Blank-category reviews belong to every category
          this.list = this.slides.filter(
            (slide) => !category || slide.dataset.category === '' || slide.dataset.category === category
          );
          this.pills.forEach((pill) => {
            const active = pill.dataset.category === category;
            pill.classList.toggle('is-active', active);
            pill.setAttribute('aria-pressed', active ? 'true' : 'false');
          });
          this.dotsEl.textContent = '';
          this.dots = this.list.map((_, i) => {
            const dot = document.createElement('button');
            dot.type = 'button';
            dot.className = 'ct-quotes__dot';
            dot.setAttribute('aria-label', 'Review ' + (i + 1) + ' of ' + this.list.length);
            dot.innerHTML = '<span class="ct-quotes__dot-fill"></span>';
            dot.addEventListener('click', () => this.show(i, true));
            this.dotsEl.append(dot);
            return dot;
          });
          this.controls.classList.toggle('is-hidden', this.list.length < 2);
          this.show(0, manual, 1);
        }

        step(direction) {
          if (!this.list || this.list.length < 2) return;
          this.show((this.index + direction + this.list.length) % this.list.length, true, direction);
        }

        show(index, manual = false, direction = 1) {
          this.index = index;
          this.slides.forEach((slide) => {
            slide.classList.remove('is-active');
            slide.setAttribute('aria-hidden', 'true');
          });
          const slide = this.list[index];
          if (!slide) return;
          slide.style.setProperty('--ct-q-x', (direction < 0 ? -16 : 16) + 'px');
          void slide.offsetWidth;
          slide.classList.add('is-active');
          slide.setAttribute('aria-hidden', 'false');
          this.dots.forEach((dot, i) => dot.classList.toggle('is-active', i === index));
          if (manual) {
            // Restart the fill even when re-selecting the current dash
            const fill = this.dots[index] && this.dots[index].querySelector('.ct-quotes__dot-fill');
            if (fill) {
              fill.style.animation = 'none';
              void fill.offsetWidth;
              fill.style.animation = '';
            }
          }
        }
      }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["ct-stages"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('ct-stages')) {
    customElements.define(
      'ct-stages',
      class CtStages extends HTMLElement {
        connectedCallback() {
          this.tabs = Array.from(this.querySelectorAll('[data-stage-tab]'));
          this.panels = Array.from(this.querySelectorAll('[data-stage-panel]'));
          this.index = 0;
          if (this.tabs.length < 2) return;

          this.tabs.forEach((tab, i) => {
            tab.addEventListener('click', () => this.select(i, true));
          });

          // The fill animation is the timer: when it completes, advance.
          // While paused (hover/focus/offscreen) it simply never completes.
          this.addEventListener('animationend', (event) => {
            if (event.animationName === 'ct-stages-fill') {
              this.select((this.index + 1) % this.tabs.length);
            }
          });

          this.addEventListener('pointerenter', (event) => {
            if (event.pointerType === 'mouse') this.classList.add('is-paused');
          });
          this.addEventListener('pointerleave', (event) => {
            if (event.pointerType === 'mouse') this.classList.remove('is-paused');
          });
          this.addEventListener('focusin', () => this.classList.add('is-paused'));
          this.addEventListener('focusout', () => this.classList.remove('is-paused'));

          new IntersectionObserver(
            (entries) => this.classList.toggle('is-offscreen', !entries[0].isIntersecting),
            { threshold: 0.3 }
          ).observe(this);

          // Touch swipe on the panel area
          const panels = this.querySelector('.ct-stages__panels');
          panels.addEventListener('touchstart', (e) => (this.touchX = e.changedTouches[0].clientX), { passive: true });
          panels.addEventListener(
            'touchend',
            (e) => {
              const dx = e.changedTouches[0].clientX - this.touchX;
              if (Math.abs(dx) < 48) return;
              const next = this.index + (dx < 0 ? 1 : -1);
              if (next >= 0 && next < this.tabs.length) this.select(next, true);
            },
            { passive: true }
          );

          this.querySelector('.ct-stages__tabs').addEventListener('keydown', (e) => {
            if (e.key !== 'ArrowRight' && e.key !== 'ArrowLeft') return;
            e.preventDefault();
            const delta = e.key === 'ArrowRight' ? 1 : -1;
            const next = (this.index + delta + this.tabs.length) % this.tabs.length;
            this.select(next, true);
            this.tabs[next].focus();
          });

          // Theme editor: show the selected block's stage and hold it.
          if (window.Shopify && Shopify.designMode) {
            document.addEventListener('shopify:block:select', (e) => {
              const idx = this.panels.indexOf(e.target.closest('[data-stage-panel]'));
              if (idx > -1) {
                this.classList.add('is-editor');
                this.select(idx, true);
              }
            });
            document.addEventListener('shopify:block:deselect', () => this.classList.remove('is-editor'));
          }
        }

        select(index, manual = false) {
          this.index = index;
          this.tabs.forEach((tab, i) => {
            const active = i === index;
            tab.classList.toggle('is-active', active);
            tab.setAttribute('aria-selected', active ? 'true' : 'false');
            tab.tabIndex = active ? 0 : -1;
          });
          this.panels.forEach((panel, i) => panel.classList.toggle('is-active', i === index));
          if (manual) {
            // Restart the fill even when re-selecting the current stage
            const fill = this.tabs[index].querySelector('.ct-stages__fill');
            fill.style.animation = 'none';
            void fill.offsetWidth;
            fill.style.animation = '';
          }
        }
      }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();
})();
